// CRM 2.0 · M12-F4 · /verify/<document>/<page code> and /verify/copy/<code>: one QR scanned with the normal phone
// camera (DC-198 / DC-200 / DC-220). Any logged-in user; the booking's live values of the fields on that page,
// masked unless the role may see full values; an old copy says "Old copy – do not sign".
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import cls from "./Crm2Verify.module.css";
import { scanOnePage } from "../../Services/Crm2Verify";
import ScanResult from "./ScanResult";

function VerifyScan() {
  const { first, second } = useParams();
  const [scan, setScan] = useState(null);
  const [problem, setProblem] = useState(null);

  useEffect(() => {
    let live = true;
    const query = first === "copy" ? { token: second } : { documentId: first, pageCode: second };
    scanOnePage(query).then((d) => live && setScan(d)).catch((e) => live && setProblem(e.message));
    return () => { live = false; };
  }, [first, second]);

  return (
    <div className={cls.page} style={{ paddingBottom: "3.2rem" }}>
      <header className={cls.header}>
        <h1 className={cls.title}>Agreement page</h1>
      </header>
      {problem && <p className={`${cls.notice} ${cls.noticeOld}`}>{problem}</p>}
      {!problem && !scan && <div className={cls.empty}>Loading…</div>}
      {scan && <ScanResult scan={scan} />}
    </div>
  );
}

export default VerifyScan;
